var _rect, _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4.3498,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6359 12.7862V10.9588H16.0367V28.9366H24.6359V27.1092H17.9716V20.2299H23.776V18.4563H17.9716V12.7862H24.6359ZM34.8475 12.8668L31.2735 17.2201L32.4827 18.2144L34.0413 16.3065V19.9611C34.0413 27.7273 27.7263 34.0423 19.9601 34.0423C12.194 34.0423 5.87891 27.7273 5.87891 19.9611C5.87891 12.195 12.194 5.87993 19.9601 5.87993V4.26758C11.3072 4.26758 4.26656 11.3082 4.26656 19.9611C4.26656 28.6141 11.3072 35.6547 19.9601 35.6547C28.5862 35.6547 35.6268 28.641 35.6537 20.0149V16.3065L37.2123 18.2144L38.4216 17.2201L34.8475 12.8668Z",
    fill: "#3859FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.eb5396f1af5d2a08b15d7f527135f6f3.svg";
export { ForwardRef as ReactComponent };